import { GridColDef } from '@mui/x-data-grid';
import { fieldEquivalences } from './props';
import { SurveyHistorical } from '../../../../shared/types/survey.interface';

export const useSurveyHistorical = (historical: SurveyHistorical[]) => {
    const columns: GridColDef[] = [
        {
            field: 'fieldChange',
            headerName: 'Campo Modificado',
            minWidth: 120,
            flex: 0.35,
            sortable: false,
            renderCell: (survey) => (
                <span>
                    {survey.row.elementos.field
                        ? fieldEquivalences[survey.row.elementos.field] ||
                          survey.row.elementos.field
                        : ''}
                </span>
            ),
        },
        {
            field: 'oldValue',
            headerName: 'Valor Anterior',
            minWidth: 120,
            flex: 0.35,
            sortable: false,
            renderCell: (survey) => (
                <span>{`${survey.row.elementos.oldValue}`}</span>
            ),
        },
        {
            field: 'newValue',
            headerName: 'Valor Nuevo',
            minWidth: 120,
            sortable: false,
            flex: 0.35,
            renderCell: (survey) => (
                <span>{`${survey.row.elementos.newValue}`}</span>
            ),
        },
        {
            field: 'process',
            headerName: 'Proceso realizado',
            minWidth: 120,
            sortable: false,
            flex: 0.25,
            renderCell: (survey) => (
                <span>{`${
                    survey.row.elementos.field === 'status'
                        ? 'Eliminación'
                        : 'Modificación'
                }`}</span>
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de modificación',
            minWidth: 100,
            sortable: false,
            flex: 0.3,
            renderCell: (survey) => (
                <span>
                    {new Date(survey.row.created_at as Date).toLocaleString()}
                </span>
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Usuario',
            minWidth: 120,
            sortable: false,
            flex: 0.35,
            renderCell: (survey) => (
                <span>
                    {survey.row.createdBy
                        ? `${survey.row.createdBy.username}`
                        : ''}
                </span>
            ),
        },
    ];

    const rows =
        historical?.flatMap((row) => {
            if (row.changes) {
                const { changes, created_at, createdBy } = row;
                return changes.map((elemento, index) => ({
                    ...row,
                    elementos: elemento,
                    id: `${row.id}-${index}`,
                    created_at,
                    createdBy,
                }));
            }
            return [];
        }) || [];

    return {
        columns,
        rows,
    };
};
